import { isNotUser, isSuperAdmin } from "@/helpers";
import {
  getAvailableInstructorList,
  getAvailableStudentList,
} from "@/services";
import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import {
  getAvailableRemainingPeople,
  getPeopleDetail,
  getUserRoleList,
  getUsersList,
  getUserTypes,
} from "../services/people.service";

const initialState = {
  usersList: [],
  filteredUsersList: [],
  unfilteredUsersList: [],
  selectedUsersList: [],
  userRoleList: null,
  allRoleList: [],
  availablePeopleList: null,
  filteredStudentList: [],
  unfilteredStudentList: [],
  filteredInstructorList: [],
  unfilteredInstructorList: [],
  filteredRemainingPeople: [],
  unfilteredRemainingPeople: [],
};

export const people = createSlice({
  name: "people",
  initialState,
  reducers: {
    resetFilteredUsersList: (state, action) => {
      state.filteredUsersList = [];
      state.unfilteredUsersList = [];
      state.selectedUsersList = [];
      state.filteredStudentList = [];
      state.filteredInstructorList = [];
      state.filteredRemainingPeople = [];
    },
    resetAvailableRemainingPeople: (state) => {
      state.filteredRemainingPeople = [];
      state.unfilteredRemainingPeople = [];
    },
    selectedUsers: (state, action) => {
      state.selectedUsersList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUsersList.fulfilled, (state, action) => {
        const { data = [], total = 0 } = action.payload || {};
        const { offset = 0, isFilter } = action.meta.arg || {};
        const filterActiveUsers = data?.filter(
          (item) => item?.status === "active"
        );
        state.usersList = data;
        state.filteredListData = null;
        state.totalUser = total;
        if (isFilter) {
          state.filteredUsersList =
            offset === 0
              ? filterActiveUsers
              : state.filteredUsersList.concat(filterActiveUsers);
        } else {
          state.unfilteredUsersList =
            offset === 0
              ? filterActiveUsers
              : state.unfilteredUsersList.concat(filterActiveUsers);
        }
      })
      .addCase(getAvailableRemainingPeople.fulfilled, (state, action) => {
        const { data = [] } = action.payload || {};
        const { offset = 0, isFilter } = action.meta.arg || {};
        // state.availablePeopleList = data;
        if (isFilter) {
          state.filteredRemainingPeople =
            offset === 0 ? data : state.filteredRemainingPeople.concat(data);
        } else {
          state.unfilteredRemainingPeople =
            offset === 0 ? data : state.unfilteredRemainingPeople.concat(data);
        }
      })
      .addCase(getUserRoleList.fulfilled, (state, action = {}) => {
        let role;
        const { payload } = action;
        if (payload && payload?.data) {
          role = isSuperAdmin()
            ? payload?.data && payload?.data?.length
              ? payload?.data
              : []
            : !isNotUser()
            ? payload?.data?.filter((role) => role?.level > 3)
            : payload?.data?.filter((role) => role.level > 2);
          role = _.sortBy(role, (role) => role.level);
        }
        return {
          ...state,
          allRoleList: _.sortBy(payload?.data, (role) => role.level),
          userRoleList: role,
        };
      })
      .addCase(getUserTypes.fulfilled, (state, action) => {
        state.userTypes = action?.payload?.data;
      })
      .addCase(getAvailableStudentList.fulfilled, (state, action) => {
        const { data = [] } = action.payload || {};
        const { offset = 0, isFilter } = action.meta.arg || {};
        // state.availablePeopleList = data;
        if (isFilter) {
          state.filteredStudentList =
            offset === 0 ? data : state.filteredStudentList.concat(data);
        } else {
          state.unfilteredStudentList =
            offset === 0 ? data : state.unfilteredStudentList.concat(data);
        }
      })
      .addCase(getAvailableInstructorList.fulfilled, (state, action) => {
        const { data = [] } = action.payload || {};
        const { offset = 0, isFilter } = action.meta.arg || {};
        // state.availablePeopleList = data;
        if (isFilter) {
          state.filteredInstructorList =
            offset === 0 ? data : state.filteredInstructorList.concat(data);
        } else {
          state.unfilteredInstructorList =
            offset === 0 ? data : state.unfilteredInstructorList.concat(data);
        }
      })
      .addCase(getPeopleDetail.rejected, (state, action) => {
        // Handle rejection if necessary
      });
  },
});

export const {
  resetAvailableRemainingPeople,
  resetFilteredUsersList,
  selectedUsers,
} = people.actions;
export default people.reducer;
